import type Immutable from 'immutable';
import { createMigration } from './utils';

export const migrationTo9_193 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });

            const musicId = map.get('musicId');
            const voiceOverId = map.get('voiceoverId');

            if (musicId) {
                const sourceData = map.getIn(['audioAssets', musicId, 'sourceData']) as Immutable.Map<any, any> | null;
                if (sourceData && sourceData.isEmpty()) {
                    map.setIn(['audioAssets', musicId, 'sourceData'], null);
                }
            }

            if (voiceOverId) {
                const sourceData = map.getIn(['audioAssets', voiceOverId, 'sourceData']) as Immutable.Map<any, any> | null;
                if (sourceData && sourceData.isEmpty()) {
                    map.setIn(['audioAssets', voiceOverId, 'sourceData'], null);
                }
            }
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations(map => {
            const voiceoverSourceData = map.getIn(['voiceoverAsset', 'sourceData']) as Immutable.Map<any, any> | null;
            if (voiceoverSourceData && voiceoverSourceData.isEmpty()) {
                map.setIn(['voiceoverAsset', 'sourceData'], null);
            }
        });
    },
});
